<template>
	<div class="section section-basic">
		<div class="container text-center">
			<h3 class="title ">Barbearias Credenciadas</h3>
			<p class="category">Encontre uma barbearia próxima a você.</p>

			<div class="row">
				<div class="col-md-4" v-for="credenciado in credenciados" v-bind:key="credenciado.codigo">
					<div v-on:click="pageRoute(credenciado.Abreviatura)" v-if="credenciado.Imagem != ''" class="card pointer bg-image-logo wh-350" v-bind:style="{'background-image': 'url(' + credenciado.Imagem  +')'}">
						<div class="block-header push-150"></div>
						<div class="bg-black-op">
							<h5><strong>{{credenciado.Nome}}</strong></h5>
							<p> <label> {{credenciado.Cidade}} </label></p>
							<p><label> {{credenciado.Endereco}} </label></p>
						</div>
					</div>
					<div v-on:click="pageRoute(credenciado.Abreviatura)" v-if="credenciado.Imagem == ''" class="card pointer bg-image-logo wh-350" v-bind:style="{'background-image': 'url(' + urlPadrao +')'}">
						<div class="block-header push-150"></div>
						<div class="bg-black-op">
							<h5><strong>{{credenciado.Nome}}</strong></h5>
							<p> <label> {{credenciado.Cidade}} </label></p>
							<p><label> {{credenciado.Endereco}} </label></p>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
	import {
		Card
	} from '@/components';

	export default {
		components: {
			Card
		},
		data() {
			return {
				credenciados: "",
				urlPadrao: "https://sites.appbarber.com.br/assets_site/images/background.png"
			};
		},
		methods: {
			listaCredenciados(credenciados){
				  this.credenciados = credenciados;
				  console.log(this.credenciados);
			},
			pageRoute(abreviatura){
				this.$router.push('/' + abreviatura);
			}
		},
		beforeCreate(){
			fetch('https://ws.appbeleza.com.br/Service.php?metodo=buscaClientesRaio&latitude=-27.090944&longitude=-52.606')
				.then(result => result.json())
				.then(credenciados => this.listaCredenciados(credenciados.result));
		}
	};
</script>
<style>
	.wh-350 {
		height: 350px;
		width: 350px;
	}
	.h-200 {
		height: 200px;
	}
	.push-150 {
		margin-bottom: 190px !important;
	}

	.bg-black-op {
		background-color: rgba(0, 0, 0, 0.6) !important;
		color: white !important;
	}
	.block-header {
		padding: 15px 20px;
		-webkit-transition: opacity 0.2s ease-out;
		transition: opacity 0.2s ease-out;
	}

	.pointer {
		cursor: pointer;
	}

</style>
